import { Icon, type JVSIcons, Segment } from '@mairistem/composants';
import React from 'react';
import type LigneNotePresentation from '../../../../interfaces/simulation/ligneNotePresentation';
import {
	estChampLibre,
	getIconeBloc,
	getTitreLigne,
} from '../../../../utils/simulation/notePresentation';
import './NotePresentationBloc.css';

interface NotePresentationBlocProps {
	ligne: LigneNotePresentation;
	onUpdate: (ligne: LigneNotePresentation) => void;
}

const NotePresentationBloc = ({
	ligne,
	onUpdate,
}: NotePresentationBlocProps) => {
	const { codeBlock, identifiant } = ligne;

	const modifiable = estChampLibre(codeBlock);
	const titre = getTitreLigne(ligne);

	const handleUpdate = () => onUpdate(ligne);

	return (
		<Segment className="notePresentationBloc">
			<Icon
				className="notePresentationBlocType"
				color="white"
				iconSet="Lucide"
				name={getIconeBloc(codeBlock) as JVSIcons}
			/>
			<span className="notePresentationBlocLibelle">
				{codeBlock}
				{titre && ` | ${titre}`}
			</span>
			{modifiable && (
				<Icon
					className="notePresentationBlocAction"
					data-testid={`updateBloc${identifiant}`}
					iconSet="Lucide"
					link
					name="Settings"
					onClick={handleUpdate}
				/>
			)}
		</Segment>
	);
};

export default NotePresentationBloc;
